'use client';

import React from 'react';
import Header from '@/components/common/Header';
import FAQInteractive from './components/FAQInteractive';
import Footer from '@/app/homepage/components/Footer';

const FAQHelpCenterPage = () => {
  return (
    <>
      <Header />
      <main className="pt-16 lg:pt-20">
        <FAQInteractive />
      </main>
      <Footer />
    </>
  );
};

export default FAQHelpCenterPage;